module.exports = __webpack_public_path__ + "static/media/devices.61c9bbf8.png";